document.addEventListener('DOMContentLoaded', () => {
    let linkTimeout: any = null;

    document.body.addEventListener('click', (e) => {
        const links = ['fmenu__link', 'menu__link'];
        links.forEach((item) => {
            let link = e.target as any;
            if (link?.classList.contains(item) || link.closest(`.${item}`)) {
                if (!link.classList.contains(item)) {
                    link = link.closest(`.${item}`);
                }

                if (linkTimeout !== null) {
                    clearTimeout(linkTimeout);
                }

                link.classList.add('link-balloon-parent');

                let span = link.querySelector('.link-balloon');
                if (span === null || span === undefined) {
                    span = document.createElement('span');
                    span.classList.add('link-balloon');
                    link.appendChild(span);
                }

                const rect = link.getBoundingClientRect();
                const x = e.pageX - rect.left;
                const y = e.pageY - rect.top;
                span.style.left = `${x}px`;
                span.style.top = `${y}px`;
                span.classList.add('link-balloon--active');
                linkTimeout = setTimeout(() => {
                    span.classList.remove('link-balloon--active');
                }, 300);
            }
        });
    });
});
